<template>
    <v-card height="200" width="350" id="map" class="basemap" ></v-card>
</template>
<script>
import mapboxgl from "mapbox-gl"
import { getCoordinates } from '@/api/run'
export default {
    props: {
        location: String,
        token: String
    },
    async mounted() {
        this.lookupAddress(this.location)
    },
    methods: {
        async lookupAddress (location) {
            mapboxgl.accessToken = this.token;
            let geoCoderLookup = await getCoordinates(encodeURIComponent(location))
            if (geoCoderLookup && geoCoderLookup.features && geoCoderLookup.features[0] && geoCoderLookup.features[0].center) {
                var coords = geoCoderLookup.features[0].center
                var map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/streets-v11',
                    center: coords,
                    zoom: 10
                });
                new mapboxgl.Marker().setLngLat(coords).addTo(map);
            }
        }
    },
    watch: {
        location: function (val) {
            if (val) {
                this.lookupAddress(val)
            }
        }
    },
}
</script>
